/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid } from '@mui/material';
import { fonts, themes } from '../themes/themes';

interface contentTileType {
  tile_key: string;
  tile_value: string;
  value_color?: string;
  key_color?: string;
  is_bold?: boolean;
  tile_value2: any;
  tile_value3: any;
  tile_value4: any;
  tile_value5: any;
}

const CardForWeekoff: React.FC<contentTileType> = ({
  tile_key,
  tile_value,
  tile_value2,
  tile_value3,
  tile_value4,
  tile_value5,
  value_color = themes.tileValue_black,
  key_color = themes.tileKey_grey,
  is_bold = false,
}) => {
  return (
    <Grid
      container
      style={{
        display: 'flex',
        marginTop: '12px',
        width: 'auto',
        paddingLeft: '18px',
        paddingRight: '18px',
        paddingTop: '10px',
        paddingBottom: '10px',
        backgroundColor: '#fafafa',
        borderRadius: '6px',
        opacity: 1,
      }}
    >
      <Grid
        item
        style={{
          flexGrow: 1,
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: key_color,
          fontWeight: is_bold ? 'bolder' : 'normal',
        }}
      >
        {tile_key}
      </Grid>
      <Grid
        item
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: value_color,
          textAlign: 'right',
          fontWeight: is_bold ? 'bolder' : 'normal',
        }}
      >
        {tile_value}
      </Grid>
      <Grid
        item
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.green,
          textAlign: 'right',
          fontWeight: is_bold ? 'bolder' : 'normal',
          marginLeft: '0.2em',
        }}
      >
        {tile_value2}
      </Grid>
      <Grid
        item
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: value_color,
          textAlign: 'right',
          fontWeight: is_bold ? 'bolder' : 'normal',
          marginLeft: '0.2em',
        }}
      >
        {tile_value4}
      </Grid>
      <Grid
        item
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.red,
          textAlign: 'right',
          fontWeight: is_bold ? 'bolder' : 'normal',
          marginLeft: '0.2em',
        }}
      >
        {tile_value3}
      </Grid>
      <Grid
        item
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: value_color,
          textAlign: 'right',
          fontWeight: is_bold ? 'bolder' : 'normal',
          marginLeft: '0.2em',
        }}
      >
        {tile_value5}
      </Grid>
    </Grid>
  );
};

export default CardForWeekoff;
